import { useCallback, useMemo } from "react";

import sharedConstants from "@lib/shared_constants.json";

import type { RealPermission, RealPermissionValue } from "@services/permissions/types";

/**
 * Returns the Permission string value based on the PermissionValue (permission numeric value) corresponding to that
 * permission. Useful utility, because currently useDeveloperHasPermissions expects the Permission string type.
 */
export const usePermissionValueToPermission = () => {
  const permissionValueToPermissionMap: Record<RealPermissionValue, RealPermission> = useMemo<
    Record<RealPermissionValue, RealPermission>
  >(() => {
    return Object.values(sharedConstants.PERMISSIONS.PERMISSIONS_BY_SCOPE).reduce<
      Record<RealPermissionValue, RealPermission>
    >(
      (acc, scopePermission) => {
        scopePermission.forEach((permission: RealPermission) => {
          acc[sharedConstants.PERMISSIONS.PERMISSIONS_BY_VALUE[permission]] = permission;
        });
        return acc;
      },
      {} as Record<RealPermissionValue, RealPermission>
    );
  }, []);

  return useCallback(
    (permissionValue: RealPermissionValue) => {
      return permissionValueToPermissionMap[permissionValue];
    },
    [permissionValueToPermissionMap]
  );
};
